module.exports = __webpack_public_path__ + "static/media/yesterdayLogo.2deeee23.png";